
// a simple Particle class

var Particle = function (_x, _y, _wait, _size) {

  // particle details: acceleration, velocity, location and radius
  this.acc = new Vector2D(0, 0.05);
  this.vel = new Vector2D(Math.random() * 2 - 1, Math.random() * 2 - 2);
  this.loc = new Vector2D(_x, _y);
  this.r = Math.random() * 10 + 15;
  this.size = _size;

  // particle life
  this.timer = 0;
  this.rotate = 0;
  this.shrink = false;
  this.wait = _wait;

  this.image = new Image();
  this.image.src = "/Trainer/images/getStarted/star.png";


  // particle life-cycle
  this.run = function () {
    this.update();
    this.render();
  }

  this.update = function () {
    if (this.wait > 0) {
      this.wait--;
      return;
    }

    // particle loop: acceleration, velocity, and location update
    //this.vel.add(this.acc);
    //this.loc.add(this.vel);
    if (this.shrink) {
      this.timer -= 0.5;
      if (this.timer <= 0) this.wait = 140;
    }
    else
      this.timer += 0.5;

    this.rotate++;
  }

  this.render = function () {
    if (this.wait > 0) return;

    this.drawImagePlus(ctx, this.loc.x, this.loc.y);
  }

  this.drawImagePlus = function (ctx, x, y) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(this.rotation());
    ctx.scale(this.size, this.size);

    var width = 25 * (this.timer / 30) * this.size;
    var height = 26 * (this.timer / 30) * this.size;

    if (width > 4 && height > 4) {
      ctx.drawImage(this.image, -(width / 2), -(height / 2), width, height);
    }

    ctx.restore();
  }

  this.rotation = function () {
    // convert to radians
    return ((this.rotate) * 6 / 180) * Math.PI;
  }

  this.dead = function () {
    //return this.timer <= 0 ? true : false;
    if (this.timer <= 0)
      this.shrink = false;
    else if (this.timer >= 30)
      this.shrink = true;

    if (this.rotate >= 60) this.rotate = 0;
  }
}
